import popupStyles from "./userExistPopup.module.css";
import doctor from "../../images/questionnaire_doctor.png";
import { BPREVEN_CLIENT_TEST_URL, BPREVEN_CLIENT_URL } from "../../utils/utils";
import { IPopupWithoutProps } from "../../utils/types";
import { tWithKeyAttr as t } from "../../i18nHelper"

function UserExistPopup({ onClose, guid }: IPopupWithoutProps & { guid: string | null }) {
    const redirect_link = (window.location.hostname.includes("test") || window.location.hostname.includes("local"))
        ? BPREVEN_CLIENT_TEST_URL : BPREVEN_CLIENT_URL;
    const message = guid ? t('PHONE_ALREADY_EXISTS') : t('PHONE_EXISTS_REDIRECT')
    const onApproval = () => {
        if (guid) {
            window.location.href = `${redirect_link}/signin/private?Guid=${guid}`
        }
        else {
            window.location.href = `${redirect_link}/login`;
        }
    }
    return (
        <article className={popupStyles.popup} data-testid="user-exist-popup">
            <h2 className={popupStyles.popup__title}>{t('USER_ALREADY_KNOWN')}</h2>
            <p className={popupStyles.popup__text}>
                {message}
            </p>
            <img
                src={doctor}
                alt="Doctor"
                className={popupStyles.popup__img}
            />
            <button
                type="button"
                data-testid= {guid ? "go-to-registration" : "go-to-login"}
                className={`${popupStyles.popup__nextBtn} hover`}
                onClick={onApproval}
            >
                {guid ? t('FINISH_REGISTRATION') : t('CONFIRM')}
            </button>
            {guid && <button
                type="button"
                className={`${popupStyles.popup__nextBtn} hover`}
                onClick={onClose}
            >{t('CONTINUE_QUESTIONNAIRE')}</button>}
        </article>
    );
}

export default UserExistPopup;
